module.exports = __webpack_public_path__ + "img/left-arrow.e7fa76cf.svg";